export function removeHtmlStyles(string) {
    return string
        .replace(/[\r\n]+/g," ")
        .replace(/<span [^<]*?font-weight: bold;">(.*?)<\/span>/g,'<strong class="text-base">$1</strong>')
        .replace(/<font.*?>(.*?)<\/font>/g, '$1')
        .replace(/style=".*?">/g, '>')
}